import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { findTicketsWithName } from "../../api/tickets";

export async function confirmDuplicateName({
  eventId,
  firstName,
  lastName,
  onConfirm,
}) {
  const tickets = await findTicketsWithName({ eventId, firstName, lastName });

  if (!tickets.length) {
    onConfirm();
    return;
  }

  modals.openConfirmModal({
    title: "Ticket with this name already exists",
    children: (
      <Text size="sm">
        {firstName} {lastName} already has a ticket for this event. Create
        another ticket with the same name?
      </Text>
    ),
    labels: { confirm: "Create anyway", cancel: "Cancel" },
    onConfirm,
  });
}
